import { Checkbox, Chip } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";

export default function GroupedAutoComplete(props) {

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" className={props.classes.iconDimentions} />;
    const checkedIcon = <CheckBoxIcon fontSize="small" className={`${props.classes.iconDimentions} ${props.classes.iconColor}`} />;
    
    const handleFilter = (options, { inputValue }) => {
        return options.filter((option) => {
            const cleanInputValue = inputValue.toLowerCase().trim();
            if (inputValue === "") {
                return true;
            }
            const containsChildValue = option.child
                .toLowerCase()
                .includes(cleanInputValue);
            const containsGroupKeyValue = option.groupKey
                .toLowerCase()
                .includes(cleanInputValue);
            return containsChildValue || containsGroupKeyValue;
        });
    };

    const handleChange = (e, value) => {
        props.onChange(value);
    }

    return (
        <Autocomplete
            disableCloseOnSelect
            limitTags={props.limitTags}
            onChange={handleChange}
            className={props.classes.autocomplete}
            placeholder={props.placeholder}
            multiple
            options={props.options}
            groupBy={(option) => option.groupKey}
            getOptionLabel={(option) => option.child}
            getOptionDisabled={((option) => {
                // Child with value all is selected
                let currentOptionAllChildSelected = !!props.value?.find((vals) => vals.groupKey === option.groupKey && vals.isSelectAllChildOption);
                // Child with value not all selected
                let currentOptionOtherChildSelected = !!props.value?.find((vals) => vals.groupKey === option.groupKey && !vals.isSelectAllChildOption);
                let isAllChildOption = option.isSelectAllChildOption;
                if (isAllChildOption && currentOptionOtherChildSelected) {
                    return true;
                } else if (!isAllChildOption && currentOptionAllChildSelected) {
                    return true;
                }
                return false;
            })}
            renderOption={(option, { selected }) => {
                return (
                    <>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        {option.child}
                    </>
                )
            }}
            renderInput={(params) => (
                <TextField {...params} label={props.placeholder} variant="outlined" />
            )}
            renderTags={(value, getTagProps) => {
                return value.map((option, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        label={`${option.groupKey} (${option.child})`}
                    />
                ));
            }}
            filterOptions={handleFilter}
        />
    );
}